<div class="main-container">
  <form [formGroup]="form" novalidate (ngSubmit)="onSubmit()">
    <mat-card appearance="outlined">
      <mat-card-title>Auto Reply Settings</mat-card-title>
      <mat-card-content>
        <div class="alert alert-danger alert-dismissible" role="alert" *ngIf="serverError">
          Error occurred
        </div>

        <app-mat-text-input formControlName="name" label="Auto Reply Name" name="name"
                            [submitted]="submitted"></app-mat-text-input>
        <app-mat-checkbox-input formControlName="isEnabled" label="Enabled" name="isEnabled"
                                [submitted]="submitted"></app-mat-checkbox-input>

        <app-mat-multiselect formControlName="phoneNumbers"
                             placeholder="Type to search phone number"
                             label="Assigned Phone Numbers"
                             name="phoneNumbers"
                             [displayPipe]="phoneNumberDisplayPipe"
                             [lookupDisplayPipe]="phoneNumberDisplayPipe"
                             [submitted]="submitted"
                             [autoCompleteValues]="availablePhoneNumbers"
                             >
        </app-mat-multiselect>

        <app-mat-multiselect [formControl]="getFormControl('keyword')"
                             label="Keyword" name="keyword" placeholder="Enter keyword..."
                             [allowCustomValue]="true"
                             [submitted]="submitted"></app-mat-multiselect>
        <app-mat-textarea-input [formControl]="getFormControl('replyMessage')" label="Reply Message"
                                name="replyMessage" [submitted]="submitted"></app-mat-textarea-input>

        <div>
          <div class="form-group">
            <table class="" style="width: 100%">
              <colgroup>
                <col style="width: 85px">
                <col style="width: 70px">
                <col style="width: 150px">
                <col style="width: 150px">
                <col>
              </colgroup>

              <thead>
              <tr>
                <th><label>Schedule</label></th>
                <th><label>Enabled</label></th>
                <th><label>Start Time</label></th>
                <th><label>End Time</label></th>
              </tr>
              </thead>
              <tbody formArrayName="schedule">
              <ng-container *ngFor="let item of scheduleData.controls; let i=index" [formGroupName]="i">
                <tr style="vertical-align: baseline;">
                  <td>
                    {{item.get('weekDay').value | weekDay}}
                  </td>
                  <td>
                    <app-mat-checkbox-input [formControl]="getFormControl('isEnabled', item)" label=""
                                            name="isEnabled-{{i}}" [submitted]="submitted" (ngModelChange)="scheduleItemChanged($event, item)"></app-mat-checkbox-input>
                  </td>
                  <td style="padding-right: 15px">
                    <app-mat-time-input [formControl]="getFormControl('startDateTime', item)"
                                        name="startTime-{{i}}"
                                        [inlineLabel]="true"
                                        [submitted]="submitted"
                    ></app-mat-time-input>
                  </td>
                  <td>
                    <app-mat-time-input [formControl]="getFormControl('endDateTime', item)" name="endTime-{{i}}"
                                        [inlineLabel]="true"
                                        [submitted]="submitted"
                                        [customErrors]="{timeMustBeSpecified: 'Time range must be specified', endTimeMustBeGreaterThanStartTime: 'End time must be greater than start time'}"
                    ></app-mat-time-input>
                  </td>
                  <td></td>
                </tr>
                <!--<tr *ngIf="!item.valid && item.errors">
                  <td colspan="4">
                        <span class="help-block" style="display: block; color: red; text-align: right;">
                          <span *ngIf="item.errors['timeMustBeSpecified']">
                            Time range must be specified
                          </span>
                          <span *ngIf="item.errors['endTimeMustBeGreaterThanStartTime']">
                            End time must be greater than start time
                          </span>
                        </span>
                  </td>
                </tr>-->
              </ng-container>
              </tbody>
            </table>
          </div>
        </div>
      </mat-card-content>
      <mat-card-actions fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
        <button type="submit" mat-raised-button color="primary" [promiseBtn]="buttonSubmitPromise"
                *ngIf="hasEditAccess">Save
        </button>
        <button type="button" mat-raised-button color="warn" class="only-icon" matTooltip="Remove automation"
                (click)="onDeleteClick()"
                *ngIf="hasDeleteAccess && model.id && model.id !== 'new'">
          <mat-icon>delete</mat-icon>
        </button>
      </mat-card-actions>
    </mat-card>
  </form>
</div>
